import { Component, signal } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { finalize } from 'rxjs';
import { FlowInvoiceInsight } from 'src/app/_types/billing.types';
import { IconsModule } from 'src/app/shared/icons/icons.module';

import { FlowInvoicesGridContext } from '../flow-invoices-grid-context';

/** Download button; hidden entirely when the invoice carries no document. */
@Component({
  selector: 'app-flow-invoice-document-renderer',
  standalone: true,
  imports: [IconsModule],
  styles: `
    :host {
      display: flex;
      align-items: center;
      height: 100%;
    }
    .download-btn {
      border: none;
      background: transparent;
      padding: 0;
      cursor: pointer;
      color: var(--gray-500);
      display: inline-flex;
    }
    .download-btn:disabled {
      opacity: 0.5;
      cursor: default;
    }
  `,
  template: `
    @if (invoice?.hasDocument) {
      <button
        type="button"
        class="download-btn"
        [disabled]="downloading()"
        [title]="invoice?.documentFilename ?? ''"
        i18n-aria-label
        aria-label="Télécharger le document"
        (click)="download()"
      >
        <app-download-cloud-icon height="16px" width="16px" />
      </button>
    }
  `,
})
export class FlowInvoiceDocumentRendererComponent
  implements ICellRendererAngularComp
{
  invoice?: FlowInvoiceInsight;

  readonly downloading = signal(false);

  private context!: FlowInvoicesGridContext;

  agInit(params: ICellRendererParams<FlowInvoiceInsight>): void {
    this.invoice = params.data;
    this.context = params.context as FlowInvoicesGridContext;
  }

  download(): void {
    if (!this.invoice || this.downloading()) return;

    this.downloading.set(true);
    this.context
      .downloadDocument(this.invoice)
      .pipe(finalize(() => this.downloading.set(false)))
      .subscribe({ error: () => undefined });
  }

  refresh(): boolean {
    return false;
  }
}
